import Link from 'next/link';

interface Props {
  href: string;
  className?: string;
  children: React.ReactNode;
}

export default function ButtonLink({ href, className, children }: Props) {
  const styleToApply =
    className || 'px-5 py-3 text-base font-semibold leading-tight text-white bg-blue-500 rounded';
  return href.startsWith('http') ? (
    <a href={href} className={styleToApply}>
      {children}
    </a>
  ) : (
    <Link href={href} className={styleToApply}>
      {children}
    </Link>
  );
}
